import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { GLASS } from './glass';

const COPY = {
    en: {
        eyebrow: 'Who it’s for',
        line1: 'Your day is done.',
        line2: 'Your mind isn’t.',
        body: 'Work, training, plans. The busy part ends, but switching off doesn’t always follow. Sleepstack is for people who want to give that moment some deliberate attention.',
        claim: 'With lemon balm, which helps you relax and supports your night’s rest.*',
        footnote: '*Health claim pending EU authorisation.',
    },
    nl: {
        eyebrow: 'Is dit voor mij?',
        line1: 'Je dag zit erop.',
        line2: 'Jij staat nog aan.',
        body: 'Werk, sporten, afspraken. Ook als de drukte voorbij is, schakel je niet altijd meteen af. Sleepstack is er voor mensen die bewust aandacht willen geven aan dat moment.',
        claim: 'Met citroenmelisse die helpt ontspannen en de nachtrust ondersteunt.*',
        footnote: '*Gezondheidsclaim in afwachting van Europese toelating.',
    },
};

const reveal = (delay = 0) => ({
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5, delay },
});

export function AudienceSection() {
    const { lang } = useLanguage();
    const c = COPY[lang] || COPY.en;

    return (
        <section className="pt-16 md:pt-20 pb-4 md:pb-6 relative" id="audience" data-testid="audience-section">
            <div className="section-container grid lg:grid-cols-[1.35fr_1fr] gap-5 lg:gap-8 items-end">
                <motion.div {...reveal()} className={`relative mt-10 p-6 sm:p-8 lg:p-10 ${GLASS}`} data-testid="audience-text-card">
                    <div
                        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-bold text-muted-foreground absolute -top-8 left-1"
                        data-testid="audience-eyebrow"
                    >
                        <span className="w-8 h-px bg-muted-foreground" />
                        {c.eyebrow}
                    </div>
                    <h2 className="heading-lg text-foreground mb-4" data-testid="audience-heading">
                        <span className="block">{c.line1}</span>
                        <span className="block text-primary">{c.line2}</span>
                    </h2>
                    <p className="text-base md:text-lg text-slate-700 leading-relaxed" data-testid="audience-body">
                        {c.body}
                    </p>
                </motion.div>
                <motion.div {...reveal(0.1)} className={`p-6 sm:p-8 lg:mb-10 ${GLASS}`} data-testid="audience-claim-card">
                    <p className="text-base md:text-lg text-foreground font-semibold leading-relaxed" data-testid="audience-claim">
                        {c.claim}
                    </p>
                    <p className="text-xs text-muted-foreground mt-3" data-testid="audience-claim-footnote">
                        {c.footnote}
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
